export default function riskMainDirective() {
  return {
    template: require('./risk-main.html'),
    restrict: 'E',
    controller: 'RiskMainController',
    controllerAs: 'riskMainVM',
    bindToController: true,
    replace: true,
    scope: {
      riskType: '=',
      tooltipAppendToSelector: '@',
    },
  };
}
